import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import * as types from 'constants/actionTypes';

export const useStopwatchCommand = () => {
  const [_, globalDispatch] = useStore(StoreTypes.global);

    const execute = useCallback(async () => {
        try {
          globalDispatch({ type: types.OPEN_STOPWATCH_MODAL })
          EventBus.emit({
            event: ReaderToolsEvent.ClickReaderToolBoxEvent,
            payload: {
              isToolboxShow: false
            }
          })
        } catch (e) {
            console.error('StopwatchCommand execute error', e);
        }
    }, [globalDispatch]);

    return { execute };
};
